module.exports = {
      id: "nagorik-usage",
      viewBox: "0 0 336 47",
      url: "/" + "svg-sprite-f1921bf4f6bf5e98a1b5d71e857b44f0.svg#nagorik",
      toString: function () {
        return this.url;
      }
    }